import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormElementDeleteService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormElementDelete = createAsyncThunk(
    'sliderGet/fetchFormElementDelete',
    async ({ id }) => {
        const response = await FormElementDeleteService(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const formElementDeleteSlice = createSlice({
    name: 'formElementDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormElementDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormElementDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormElementDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formElementDeleteSlice.reducer;
